import { Card, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

import { ContactType } from 'generated/types';

interface StyledCardProps {
  expanded?: boolean;
}

export const StyledContactCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'expanded',
})<StyledCardProps>(({ theme, expanded }) => ({
  cursor: 'pointer',
  borderRadius: theme.shape.borderRadius * 1.5,
  border: `1px solid ${expanded ? theme.palette.primary.main : theme.palette.divider}`,
  transition: theme.transitions.create(['border-color', 'box-shadow'], {
    duration: theme.transitions.duration.short,
  }),
  '&:hover': {
    borderColor: theme.palette.primary.light,
  },
}));

interface RoleChipProps {
  contactType?: string;
}

export const RoleChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'contactType',
})<RoleChipProps>(({ theme, contactType }) => ({
  fontWeight: 600,
  fontSize: '0.6875rem',
  height: 24,
  ...(contactType === ContactType.Organization
    ? {
        backgroundColor: theme.palette.purple.main + '1F',
        color: theme.palette.purple.main,
      }
    : {
        backgroundColor: theme.palette.teal.main + '1F',
        color: theme.palette.teal.main,
      }),
}));
